import { Image } from "antd";
import { PLACEHOLDER_IN_BASE64 } from "constants/common";
import { chunk } from "lodash";
import { useMemo } from "react";
import { StyledWrapper } from "styled-components/Common/CommonStyled";
import {
	StyledAnimatedGallery,
	StyledAnimatedGalleryItem,
	StyledAnimatedGalleryWrapper,
} from "styled-components/WidgetBuilder/WidgetGallery";

const WidgetAnimatedGallery = (props) => {
	const { animatedMediaList = [], isMobile } = props;
	const REQUIRED_ITEM_COUNT = 16;

	const chunkMedia = useMemo(() => {
		const GRID_SIZE = 4;
		const newList = [...animatedMediaList];
		let index = 0;

		// Make sure the array always contains 16 items
		while (newList.length < REQUIRED_ITEM_COUNT) {
			newList.push({ ...newList[index % animatedMediaList.length] });
			index += 1;
		}

		// Generate 4 rotated versions of the list
		const result = Array.from({ length: GRID_SIZE }, (_, rotationIndex) => {
			const chunked = chunk(newList, GRID_SIZE); // Break into rows of 4

			return chunked.flatMap((row) => {
				return Array.from({ length: GRID_SIZE }, (_, columnIndex) => {
					const rotatedIndex = (rotationIndex + columnIndex) % GRID_SIZE;
					return row[rotatedIndex];
				});
			});
		});

		return result;
	}, [animatedMediaList]);

	const renderChildImageGroup = (arr, direction) => {
		return (
			<div className="image-holder">
				<div className={`images ${direction}`}>
					{arr.map((media) => {
						const key = `${media.id}${Math.random()}`;
						return (
							<Image
								preview={false}
								src={media.thumbnail || media.blobUrl}
								alt="Widget Gallery Thumbnail"
								key={key}
								fallback={PLACEHOLDER_IN_BASE64.IMAGE}
							/>
						);
					})}
				</div>
			</div>
		);
	};

	// Followed by TeamPixel
	const renderBlockChildMedia = (arr, index) => {
		const chunksBlock = chunk(arr, 4);

		// Define the rotation pattern for each block-child
		const rotationPattern = [
			[0, 1, 2, 3],
			[1, 2, 3, 0],
			[2, 3, 0, 1],
			[3, 0, 1, 2],
			[0, 1, 2, 3],
			[1, 2, 3, 0],
		];

		const classNameList = ["clockwise", "counterClockwise", "counterClockwise", "clockwise"];

		return (
			<StyledWrapper key={index}>
				{rotationPattern.map((pattern, blockIndex) => {
					const key = `${blockIndex}`;

					return (
						<StyledAnimatedGalleryItem className="block-child" key={key}>
							{pattern.map((chunkIndex, i) =>
								renderChildImageGroup(chunksBlock[chunkIndex], classNameList[i]),
							)}
						</StyledAnimatedGalleryItem>
					);
				})}
			</StyledWrapper>
		);
	};

	return (
		<>
			<StyledAnimatedGalleryWrapper className="block-parent-wrapper">
				<StyledAnimatedGallery className="block-parent" isMobile={isMobile}>
					{chunkMedia.map((item, index) => {
						return renderBlockChildMedia(item, index);
					})}
				</StyledAnimatedGallery>
			</StyledAnimatedGalleryWrapper>
		</>
	);
};

export default WidgetAnimatedGallery;
